const envConfig = 'ebankingweb';

const rmRegion ="rmch"

module.exports = { envConfig, rmRegion };
